import { Actions, ActionTypes } from '../actions/device-configuration.action';
import { DeviceConfigurationReducer } from '../models/device-configuration.model';

export const INITIAL_STATE: DeviceConfigurationReducer = {
  id: 0,
  deviceId: 0,
  comment: '',
  isLocallyChanged: false,
  hasVpnServerChanged: false,
  version: 0,
  isVersionChanged: false,
  deviceBasicDetails: {
    name: '',
    uuid: '',
    location: '',
    latitude: 0,
    longitude: 0,
    organization: {
      id: 0,
      name: '',
      description: '',
      uuid: '',
      client_name: '',
      client_email: '',
      client_mobile_no: '',
      client_address: '',
      devices_count: 0,
      provisioned_devices_count: 0,
      created_by: 0,
      updated_by: 0,
      created_at: '',
      updated_at: '',
    },
    organizationId: 0,
    isDeviceOnline: false,
    deviceState: null,
    isSuricataEnabled: false,
  },
  activeNetSubService: '',
  activeTsSubService: '',
  activeTsSettingsSubService: '',
  activeVPNSubService: '',
  activeSuricataSubService: '',
  activeRoutingSubService: '',
  activeDynamicRoutingSubService: '',
  activeDnsSubService: '',
  organizationSettings: {
    enable_vpn_and_routing_configurations: false,
    enable_traffic_steering_configurations: false,
    enable_suricata_configurations: false,
    organization_id: 0,
  },
};

export function deviceConfigurationReducer(state = INITIAL_STATE, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_CONIG_BY_DEVICE_ID:
      const config = action.payload;
      return {
        ...state,
        id: config.id,
        deviceId: config.device_id,
        comment: config.comment,
        isLocallyChanged: false,
      };
    case ActionTypes.SET_LOCALLY_CHANGED_FIELD:
      return {
        ...state,
        isLocallyChanged: action.payload,
      };
    case ActionTypes.SET_VPN_SERVER_CHANGED_FLAG:
      return {
        ...state,
        hasVpnServerChanged: action.payload,
      };
    case ActionTypes.SET_CONFIGURATION_VERSION:
      return {
        ...state,
        version: action.payload,
      };
    case ActionTypes.SET_VERSION_CHANGED:
      return {
        ...state,
        isVersionChanged: action.payload,
      };
    case ActionTypes.SET_DEVICE_BASIC_DETAILS:
      return {
        ...state,
        deviceBasicDetails: action.payload,
      };
    case ActionTypes.SET_ACTIVE_NET_SUB_SERVICE:
      return {
        ...state,
        activeNetSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_TS_SUB_SERVICE:
      return {
        ...state,
        activeTsSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_TS_SETTINGS_SUB_SERVICE:
      return {
        ...state,
        activeTsSettingsSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_VPN_SUB_SERVICE:
      return {
        ...state,
        activeVPNSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_SURICATA_SUB_SERVICE:
      return {
        ...state,
        activeSuricataSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_ROUTING_SUB_SERVICE:
      return {
        ...state,
        activeRoutingSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_DYNAMIC_ROUTING_SUB_SERVICE:
      return {
        ...state,
        activeDynamicRoutingSubService: action.payload,
      };
    case ActionTypes.SET_ACTIVE_DNS_SUB_SERVICE:
      return {
        ...state,
        activeDnsSubService: action.payload,
      };
    case ActionTypes.SET_ORGANIZATION_SETTINGS:
      return {
        ...state,
        organizationSettings: action.payload,
      };
    default:
      return state;
  }
}
